<template>
	
<div class="next" :class="{'is-large': large, 'is-down': down, 'is-dark': dark, [clsTheme]: true}">

	<div class="next-text" v-if="!text">Next</div>
	<div class="next-text" v-if="text">{{ text }}</div>
	<div class="next-icon" :class="{[clsIcon]: true}"></div>

</div>

</template>

<script>

export default {

	props: ['large', 'down', 'dark', 'text', 'icon', 'color'],

	computed: {

		clsIcon: function() {

			return (this.icon) ? 'is-' + this.icon : 'is-chevron'

		},

		clsTheme: function() {

			return (this.color) ? 'is-' + this.color : 'is-default'

		}

	}
	
}

</script>

<style scoped>

.next {
	display: flex;
	height: 36px;
	cursor: pointer;
	align-items: center;
}

.next.is-large {
	height: 64px;
}

.next-text {
	color: #fff;
	font-size: 12px;
	letter-spacing: 1px;
	font-weight: bold;
	text-transform: uppercase;
	margin-right: 12px;
}

.next.is-dark .next-text {
	color: #343434;
}

.next-icon {
	width: 36px;
	height: 36px;
	border-radius: 18px;
	background-color: #fff;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.next-icon.is-chevron {
	background-image: url(~@/assets/aid/common/next.svg);
}

.next-icon.is-graph {
	background-image: url(~@/assets/aid/risk/risk/cates.svg);
}

.next.is-down .next-icon.is-chevron {
	background-image: url(~@/assets/aid/common/next.down.svg);
}

.next.is-down.is-large .next-icon.is-chevron {
	background-image: url(~@/assets/aid/common/next.down.large.svg);
}

.next.is-dark.is-default .next-icon {
	background-color: #F8A533;
}

.next.is-dark.is-grey .next-icon {
	background-color: #656D78;
}

.next.is-large .next-icon {
	width: 64px;
	height: 64px;
	border-radius: 32px;
}

</style>